module.exports = __webpack_public_path__ + "BR.svg?04de9ebfd22bb03bade8677a94730a81";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/symbols/BR.svg
// module id = 55
// module chunks = 0